const TOKEN_RULES: Record<string, RegExp> = {
  "9": /[0-9]/,
  a: /[a-zA-Z]/,
  "*": /[a-zA-Z0-9]/,
};

const isToken = (char: string): boolean => TOKEN_RULES[char] !== undefined;

const sanitizeInput = (value: string): string => value.replace(/[^a-zA-Z0-9]/g, "");

export const applyMask = (value: string, mask: string): string => {
  const input = sanitizeInput(value || "");
  let inputIndex = 0;
  let maskIndex = 0;
  let result = "";

  while (maskIndex < mask.length && inputIndex < input.length) {
    const maskChar = mask[maskIndex];

    if (!isToken(maskChar)) {
      result += maskChar;
      maskIndex += 1;
      continue;
    }

    const tokenRule = TOKEN_RULES[maskChar];
    let accepted = false;

    while (inputIndex < input.length) {
      const candidate = input[inputIndex];
      inputIndex += 1;

      if (tokenRule.test(candidate)) {
        result += candidate;
        accepted = true;
        break;
      }
    }

    if (!accepted) {
      break;
    }

    maskIndex += 1;
  }

  return result;
};
